module.exports = "/_next/static/images/a7b119fe317e18bf1d111e4a56c9e838-hero-desktop-v1.jpg.webp";